import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createFailureRequestItemService,
  deleteFailureRequestItemService,
  editFailureRequestItemService,
  getFailureRequestItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const failureRequestAdminContext = createContext({
  failureRequestItems: [],
  setFailureRequestItems: () => {},
  failureRequest: {},
  setFailureRequest: () => {},
  id: "",
  setId: () => {},
  icon: "",
  setIcon: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetFailureRequestItemList: () => {},
  handleCreateFailureRequestItem: () => {},
  handleEditFailureRequestItem: () => {},
  handleDeleteFailureRequestItem: () => {},
});

const FailureRequestAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [failureRequestItems, setFailureRequestItems] = useState([]);
  const [failureRequest, setFailureRequest] = useState({});
  const [id, setId] = useState("");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setIcon("");
    setDescription("");
  };

  // Create Failure Request Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setIcon(itemValue.icon);
      setDescription(itemValue.description);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details Failure Request Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setFailureRequest(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setFailureRequest({});
  };

  // Handle Get Failure Request Item List Method
  const handleGetFailureRequestItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailureRequestItemsService(objData);
      if (status === 200) {
        setFailureRequestItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Failure Request Item Method
  const handleCreateFailureRequestItem = async (event) => {
    event?.preventDefault();

    const objData = {
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createFailureRequestItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetFailureRequestItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Failure Request Item Method
  const handleEditFailureRequestItem = async (event) => {
    event?.preventDefault();

    const objData = {
      id,
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editFailureRequestItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetFailureRequestItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Failure Request Item Method
  const handleDeleteFailureRequestItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteFailureRequestItemService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetFailureRequestItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <failureRequestAdminContext.Provider
      value={{
        failureRequestItems,
        setFailureRequestItems,
        failureRequest,
        setFailureRequest,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        icon,
        setIcon,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetFailureRequestItemList,
        handleCreateFailureRequestItem,
        handleEditFailureRequestItem,
        handleDeleteFailureRequestItem,
      }}
    >
      {children}
    </failureRequestAdminContext.Provider>
  );
};

export default FailureRequestAdminContext;
